export default __webpack_public_path__ + "static/media/dance_preview.72bdb94b.jpg";